import React from "react";
import { useSelector } from "react-redux";

export default function ValidateAccess({
  accessKey,
  children,
}: {
  accessKey: string;
  children: React.ReactNode;
}) {
  const permissions = useSelector((state: any) => state.permissions);

  console.log(
    "accessKey ? permissions[accessKey] : false :>> ",
    accessKey,
    accessKey ? (permissions[accessKey] ? true : false) : false
  );

  const hasAccess = accessKey ? permissions[accessKey] : false;

  if (hasAccess) {
    return <>{children}</>;
  }
  return null;
}

export function ValidateAccessValue(accessKey: string): boolean {
  const permissions = useSelector((state: any) => state.permissions);
  const hasAccess = accessKey ? permissions[accessKey] : false;
  return hasAccess;
}
